<ngx-spinner type="ball-atom"></ngx-spinner>
<div class="component-container">
  <div class="component-header">
    <h2>Create New Company</h2>
  </div>
  <app-company-form
    submitButtonText="Create Company"
    (submit)="onSubmit()"
    (cancel)="onCancel()">
  </app-company-form>
</div>
